import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-files-cloud-download-icon',
  templateUrl: './files-cloud-download.component.html'
})
export class FilesCloudDownloadComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
